export const adminPermissions = [
    'admin_dashboard_read',
    'admin_courses_read',
    'admin_courses_write',
    'admin_modules_read',
    'admin_modules_write',
    'admin_users_read',
    'admin_users_write',
    'admin_passwordless_access_write',
    'admin_grow_write',
    'admin_question_library_write',
    'admin_teams_write',
    'admin_performance_review_write',
    'admin_certification_write',
    'admin_settings_write',
    'admin_reports_write',
    'admin_career_model_write',
    'admin_qualifications_write',
    'tenant_management',
];
